// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InputFieldComponent-commonNoteText-h_CX8 {
    color: var(--secondary-foreground);
    margin: 0;
    font-size: 14px;
    margin-top: 6px;
}`, "",{"version":3,"sources":["webpack://./src/components/Common/InputFieldComponent/InputFieldComponent.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;IAClC,SAAS;IACT,eAAe;IACf,eAAe;AACnB","sourcesContent":[".commonNoteText {\n    color: var(--secondary-foreground);\n    margin: 0;\n    font-size: 14px;\n    margin-top: 6px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"commonNoteText": `InputFieldComponent-commonNoteText-h_CX8`
};
module.exports = ___CSS_LOADER_EXPORT___;
